<template>
  <div class="form2">
    <div class="page_form">
      <el-form label-width="200px" size="small">
        <el-form-item label="邀请成功条件">
          <el-checkbox-group v-model="formData.condition">
            <el-checkbox label="new_register">被邀人注册会员</el-checkbox>
            <el-checkbox label="first_custom">被邀人完成消费</el-checkbox>
          </el-checkbox-group>
          <div class="extra_line">
            <span>消费</span>
            <span>
              <el-select v-model="formData.custom.goods_id" multiple placeholder="请选择" @change="handleGood">
                <el-option-group
                  v-for="group in oilsOptions"
                  :key="group.id"
                  :label="group.name">
                  <el-option
                    v-for="item in group.options"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-option-group>
              </el-select>
             </span>
            <span>
              <el-select class="select_box2" v-model="formData.custom.original">
                <el-option label="原价" value="1"></el-option>
                <el-option label="实付" value="0"></el-option>
              </el-select>
            </span>
            <span>满</span>
            <span>
              <el-input class="select_box2" v-model="formData.custom.money"></el-input>
            </span>
            <span>元</span>
          </div>
        </el-form-item>
        <el-form-item label="邀请成功奖励">
          <div class="send_line">
            <span style="margin-right:15px">优惠券</span>
            <div class="padding10">
              <el-tag
                v-for="(tag, index) in formData.reward.coupon"
                :key="tag.id"
                closable
                @close="delTagItem(index)"
                style="margin-bottom:5px;margin-right:5px;"
              >
                {{ tag.name }}
                <span v-if="tag.choseNum != 1">
                  <span class="colorRed">×</span>{{ tag.choseNum }} 张
                </span>
              </el-tag>
            </div>
            <el-button @click="selectCoupon(-1)">选择优惠券</el-button>
          </div>
          <div class="send_line">
            <span style="margin-right:15px">积分</span>
            <el-input v-model="formData.reward.point" class="small_input"></el-input>
          </div>
          <div class="send_line">
            <span style="margin-right:15px">余额</span>
            <el-input v-model="formData.reward.balance" class="small_input"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="邀请阶梯奖励">
          <el-switch v-model="formData.is_level" @change="changeLevel"></el-switch>
          <el-popover
            placement="bottom"
            width="270"
            trigger="click"
            title="邀请阶梯奖励"
            content="邀请人成功邀请好友的数量达到一定值时，给邀请人发放阶梯奖励。">
            <el-button slot="reference" type="text" class="ques_button">
              <i class="el-icon-question"></i>
            </el-button>
          </el-popover>
          <div class="level_box" v-show="this.formData.is_level">
            <div class="level_item" v-for="(item,index) in levelForm" :key="index">
              <div class="level_item_line">
                <div class="item_label">阶梯{{index+1}}</div>
                <div class="item_value">邀请成功
                  <el-input class="small_input" v-model="item.invite_num"></el-input>人
                </div>
              </div>
              <div class="level_item_line">
                <div class="item_label">邀请成功奖励</div>
                <div class="item_value">
                  <div class="send_line">
                    <span style="margin-right: 15px">优惠券</span>
                    <div class="padding10">
                      <el-tag
                        v-for="(tag, i) in item.coupon"
                        :key="tag.id"
                        closable
                        @close="delLevelTagItem(index,i)"
                        style="margin-bottom:5px;margin-right:5px;"
                      >
                        {{ tag.name }}
                        <span v-if="tag.choseNum != 1">
                          <span class="colorRed">×</span>{{ tag.choseNum }} 张
                        </span>
                      </el-tag>
                    </div>
                    <el-button @click="selectCoupon(index)">选择优惠券</el-button>
                  </div>
                  <div class="send_line">
                    <span style="margin-right: 15px">积分</span>
                    <el-input v-model="item.point" class="small_input"></el-input>
                  </div>
                  <div class="send_line">
                    <span style="margin-right: 15px">余额</span>
                    <el-input v-model="item.balance" class="small_input"></el-input>
                  </div>
                  <el-button type="danger" icon="el-icon-delete" class="block_checkbox" @click="delItem(index)">删除</el-button>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item v-show="this.formData.is_level">
          <el-button icon="el-icon-plus" @click="addLevel">添加阶梯</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-form label-width="200px">
      <el-form-item>
        <div style="margin-top: 30px">
          <el-button @click="lastStep()">上一步</el-button>
          <el-button type="primary" @click="nextStep()">下一步</el-button>
        </div>
      </el-form-item>
    </el-form>
    <el-dialog :visible.sync="showSelecter" @close="showSelecter = false" width="840px">
      <newSelectCommodityNum
        @close="showSelecter = false"
        @getCommod="getCommod"
        :sList="sList"
        :jude="2"
      ></newSelectCommodityNum>
    </el-dialog>
  </div>
</template>
<script>
import { goodsOptions, oilsTypeOptions } from "@/api/vip";
import newSelectCommodityNum from "@/components/commodity/newSelectCommodityNum.vue";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "inviteForm"])
  },
  components: {
    newSelectCommodityNum
  },
  data(){
    return{
      formData:{
        condition: [], // 邀请成功条件
        // consumeType: "0", // 消费条件
        sendType: [], // 奖励类型 优惠券/积分/余额
        is_level: false, // 阶梯奖励
        oilsType: [], // 油品选项
        custom: {
          goods_id: [],
          goods_name: "",
          original: "",
          money: ""
        },
        reward:{
          point: "",
          balance: "",
          coupon: [], // 选择的优惠券
        }
      },
      levelForm:[
        {invite_num: "1", sendType: [], point: "", balance: "", coupon: []},
      ],
      showSelecter: false,
      sList: [],
      selectIndex: 0, // 阶梯奖励优惠券index
      oilsOptions: [
        {id:"",name: "",options: []}
      ], // 油品选项
      oilsList: [],
    }
  },
  mounted(){
    this.init();
  },
  methods:{
    init(){
      var _this = this;
      var type = [];
      var data = {
        token: this.token,
        app_id: this.app_id
      }
      oilsTypeOptions(data).then(resData => {
        if(resData.code == 200){
          resData.data.forEach(t => {
            t.options = [];
            type.push(t);
          })
          goodsOptions(data).then(res => {
            if(res.code == 200){
              this.oilsList = res.data;
              res.data.forEach(item => {
                var i = type.findIndex(x => x.id == item.type_id);
                type[i].options.push(item)
              })
              _this.oilsOptions = type;
              console.log(_this.oilsOptions)
            }
          })
        }
      })
    },
    nextStep(){
      var step_reward = [];
      if(this.formData.is_level){
        this.levelForm.forEach(item => {
          var sc = [];
          item.coupon.forEach(scItem => {
            var i = 0;
            do{
              sc.push(scItem.id);
              i++;
            }while(i < scItem.choseNum)
          })
          var itemData = {
            invite_num: item.invite_num,
            invite_reward: {
              point: item.point,
              balance: item.balance,
              coupon: sc.join(',')
            }
          }
          console.log(itemData)
          step_reward.push(itemData)
        })
      }
      var c = [];
      this.formData.reward.coupon.forEach( cItem => {
        console.log(cItem)
        var i = 0;
        do{
          c.push(cItem.id);
          i++;
        }while(i<cItem.choseNum)
      })
      var thisForm = {
        new_register: this.formData.condition.some(x => x == "new_register")? 1:0,
        first_custom: this.formData.condition.some(x => x == "first_custom")? 1:0,
        custom: {
          goods_id: this.formData.custom.goods_id.join(','),
          goods_name: this.formData.custom.goods_name,
          original: this.formData.custom.original,
          money: this.formData.custom.money
        },
        reward: {
          point: this.formData.reward.point,
          balance: this.formData.reward.balance,
          coupon: c.join(",")
        },
        step_reward: step_reward
      }
      var newData1 = Object.assign(thisForm,this.inviteForm)
      console.log("step2----",newData1)
      this.$store.commit("SET_INVITEFORM",newData1);
      // return false;
      this.$emit('nextStep')
    },
    lastStep(){
      this.$emit('lastStep')
    },
    addLevel(){
      var i = { invite_num: "", sendType: [], point: "", balance: "", coupon: [] };
      this.levelForm.push(i)
    },
    delItem(i){
      this.levelForm.splice(i,1)
    },
    //选择优惠券
    getCommod(data) {
      console.log(data);
      console.log(this.selectIndex)
      this.showSelecter = false;
      if(this.selectIndex == -1){
        this.formData.reward.coupon = data;
      }else{
        this.levelForm[this.selectIndex].coupon = data;
      }
    },
    //删除选择的优惠券
    delTagItem(i) {
      this.formData.reward.coupon.splice(i, 1);
    },
    changeLevel(val){
      if(!val){
        this.sList = [];
      }
    },
    delLevelTagItem(index,i){
      this.levelForm[index].coupon.splice(i,1)
      console.log(this.levelForm[index])
    },
    selectCoupon(i){
      console.log(i)
      this.selectIndex = i;
      if(i == -1){
        this.sList = Object.assign([],this.formData.reward.coupon);
      }else{
        this.sList = Object.assign([],this.levelForm[i].coupon);
      }
      this.showSelecter = true;
    },
    handleGood(val){
      var name = [];
      val.forEach(item => {
        name.push(this.oilsList.find(x => x.id == item).name)
      })
      console.log(name)
      this.formData.custom.goods_name = name.join('/')
    }
  }
}
</script>
<style lang="scss" scoped>
.page_form{
  margin-top: 20px;
}
.select_box1{
  width: 140px;
}
.select_box2{
  width: 90px;
}
.extra_line{
  margin-top: 20px;
  span{
    margin-right: 10px;
  }
}
.block_checkbox{
  display: block;
  margin-bottom: 10px;
}
.ques_button{
  font-size: 21px;
  margin-left: 10px;
  vertical-align: middle;
  padding: 0
}
.level_item{
  margin-top: 15px;
  margin-left: -111px;
  .level_item_line{
    margin-top: 10px;
    display: flex;
    .item_label{
      width: 100px;
      text-align: right;
      margin-right: 15px;
    }
    .item_value{
      flex: 1;
    }
  }
}
.small_input{
  width: 70px;
  margin: 0 5px;
}
.padding10 {
  padding: 0 10px;
  display: inline-block;
}
.send_line{
  height: 38px;
  margin-bottom: 10px;
}
</style>